export const DOWNLOAD_CONFIG = {
  logs: {
    fetcher: 'fetchLogs',
    mimeType: 'text/plain;charset=utf-8',
    extension: 'txt',
  },
  bundle: {
    fetcher: 'fetchBundle',
    mimeType: 'application/gzip',
    extension: 'tar.gz',
  },
  flamegraph: {
    fetcher: 'fetchFlamegraph',
    mimeType: 'image/svg+xml',
    extension: 'svg',
  },
  metrics: {
    fetcher: 'fetchMetrics',
    mimeType: 'application/gzip',
    extension: 'tar.gz',
  },
} as const

export type DownloadRequestType = keyof typeof DOWNLOAD_CONFIG
